(function($) {

    // functions 

    function stickyMenu(limit){
        if (jQuery(document).scrollTop() > limit) {
            jQuery('#site-header').addClass('is-sticky');
        } else {
            jQuery('#site-header').removeClass('is-sticky');
        }
    }

    function switchTitle( $el ) {
        var lastTitle = $el.attr( 'title' );
        $el.attr( 'title', $el.data( 'alt-title' ) );
        $el.data( 'alt-title', lastTitle );
    }

    function removeSearchActive(e) {
        if( !$( e.target ).parents( '.search-form' ).length ) {
            var parentForm = submitBtn.parents('.search-form');
            parentForm.removeClass( 'active' );
            switchTitle( submitBtn );
            $( 'body' ).off( 'click', removeSearchActive );
        }
    }

    function initSubmitSearch() {
        $( '#site-header .search-form [type="submit"]' ).on( 'click', function(e) {
            var $submitBtn = $( this );
            var $parentForm = $submitBtn.parents( '.search-form' );
    
            if( !$parentForm.hasClass( 'active' ) ) {
                e.preventDefault();
                e.stopPropagation();
                $parentForm.addClass( 'active' );
                $parentForm.find( '[type="search"]' ).focus();
                switchTitle( $submitBtn );
                $( 'body' ).on( 'click', removeSearchActive );
            }
            
        });
        
    }



    $(document).ready(function(){

        // document ready

        initSubmitSearch();

        var headerPos = 50;
        // peut-etre necessaire, peut-etre pas
        /* if(0 < $('#info-bar').length){
          headerPos = $('#info-bar').outerHeight();
        } */
    
        stickyMenu(headerPos);

        $(window).on('scroll', function() {
            stickyMenu(headerPos);
          });

    });
    
    
    })(jQuery);